import * as lib from '/src/components/_JS/lib'
import * as session from '/src/components/_JS/session'

import * as controlConfig from '/src/components/config/control-config'

import axios from 'axios'
let ajax = axios

import moment from 'moment'

export {
    lib,
    session,

    controlConfig,

    ajax,
    moment
}
